import React from 'react';
import { Cluster } from '@antonpodolsky/design-system/layout/cluster/cluster';
import { AddonButtonWithRating } from './addon-button-with-rating';
import { BROWSER_LIST } from './addon-browsers';

export const AddonButtonsWithRatings = () => (
  <Cluster gap="lg" rowGap="xl">
    {BROWSER_LIST.map((browser) => (
      <AddonButtonWithRating key={browser} browser={browser} />
    ))}
  </Cluster>
);
